import React, { useState } from "react";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import { services_helper } from "@/helpers/services_helper";
import Body from "@/ui/Body";
import Button from "../../components/Button";

export const ServicesHighlights = ({ className, title }) => {
  const items = services_helper.fetch();
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className={`${classes.services} ${className}`}>
      <div className={classes.header}>
        <Title tag="h2" title={title} className={`highlight primary`} />
      </div>
      <div className={classes.tiles}>
        {items.map(({ title, image, description, link }, k) => (
          <div
            key={title}
            className={`${classes.tile} ${k == activeIndex ? classes.active : ""}`}
            onClick={() => handleClick(k)}
          >
            <img alt={title} src={image} className={classes.image} />
            <div className={classes.content}>
              {k == activeIndex ? (
                <Title title={title} tag={"h3"} className={`text-white font-regular ${classes.title_active}`} />
              ) : (
                <Title title={title} tag={"div"} className={`h6 text-white font-regular ${classes.title_inactive}`} />
              )}
              {k == activeIndex ? (
                <Body body={description} className={`text-white pb-4 ${classes.description}`} />
              ) : (
                <></>
              )}
              {k == activeIndex && link ? (
                <Button link={link} display={`Get In Touch`} className={`btn-primary`} />
              ) : (
                <></>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesHighlights;
